<template>
  <div>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.title"
      clearable
      placeholder="请输入标题"
    ></el-input>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.status"
      clearable
      placeholder="课程状态"
    >
      <el-option label="全部课程状态" value="">全部课程状态</el-option>
      <el-option label="已发布" value="1">已发布</el-option>
      <el-option label="未发布" value="2">未发布</el-option>
    </el-select>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.type"
      clearable
      placeholder="类型"
    >
      <el-option label="全部类型" value="">全部类型</el-option>
      <el-option label="音频" value="1">音频</el-option>
      <el-option label="视频" value="2">视频</el-option>
      <el-option label="图文" value="3">图文</el-option>
      <el-option label="直播" value="4">直播</el-option>
    </el-select>

    <el-button type="primary" size="mini" @click="getList()"> 查询 </el-button>
    <el-button type="primary" size="mini" @click="dialogVisible = true"> 添加百家云点播 </el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="5%"
        ></el-table-column>        

        <el-table-column label="类型" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <span v-if="row.type == 1">音频</span>
            <span v-if="row.type == 2">视频</span>
            <span v-if="row.type == 3">图文</span>
            <span v-if="row.type == 4 && row.live_type == 1">常规直播</span>
            <span v-if="row.type == 4 && row.live_type == 2">互动直播</span>
            <span v-if="row.type == 4 && row.live_type == 3">语音图片直播</span>
            <span v-if="row.type == 4 && row.live_type == 4">推流直播</span>
            <span v-if="row.type == 4 && row.live_type == 6">伪直播</span>
          </template>
        </el-table-column>

        <el-table-column label="标题" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="toCreate(row.id)"
              disabled
            >
              <div>{{ row.title }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="时长" align="center" min-width="10%">
          <template slot-scope="{ row }">
            {{ durationShow(row.duration) }}
          </template>
        </el-table-column>

        <el-table-column label="试听/看" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <span v-if="row.is_free == 0">不允许</span>
            <span v-if="row.is_free == 1"
              >允许 {{ durationShow(row.free_duration) }}</span
            >
          </template>
        </el-table-column>

        <el-table-column label="排序" align="center" min-width="5%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateSort(row.id)">
              <div>{{ row.sort }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          prop="released_at"
          label="发布时间"
          align="center"
          min-width="12%"
        ></el-table-column>

        <el-table-column label="直播时间" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <div v-if="row.type == 4">
              {{ formatDateTime(row.begin_at, "yyyy-MM-dd hh:mm") }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" min-width="12%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.status == 1" style="color: #67c23a"
                ><i class="el-icon-circle-check"></i> 已发布</span
              >
              <span v-else style="color: #909399"
                ><i class="el-icon-circle-close"></i> 未发布</span
              >
              <el-button
                type="text"
                size="small"
                style="margin-left: 5px"
                @click="
                  row.status == 1
                    ? updateStatus(row.id, 0)
                    : updateStatus(row.id, 1)
                "
              >
                {{ row.status == 1 ? "下架" : "发布" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="20%">
          <template slot-scope="{ row }">
            <el-button type="danger" size="mini" @click="del(row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div> </el-row
    >

    <el-dialog
    title="添加百家云点播"
    :visible.sync="dialogVisible"
    :close-on-click-modal='false'
    :close-on-press-escape='false'
    width="50%">
    <el-form :model="baijiayunPeriod" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="标题">
        <el-input v-model="baijiayunPeriod.title" placeholder="输入标题，不填将使用百家云音视频标题" style="width:66%"></el-input>
      </el-form-item>
      <el-form-item label="百家云点播ID">
        <el-input v-model="baijiayunPeriod.video_id" style="width:66%"></el-input>
      </el-form-item>
      <el-form-item>
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="createBaijiayunPeriod()" :loading="updateLoading">确 定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
  </div>
</template>

<script>
import { formatDateTime, formatSeconds } from "@/api/common";
import {
  getPeriodList as getList,
  updateStatusPeriod,
  deletePeriod,
  updateSortPeriod,
  baiJiaYunVideoCreatePeriod
} from "@/api/course";

export default {
  data: function () {
    return {
      list: [],
      loading: false,
      total: 0,
      query: {
        id: this.$route.query.id,
        term_id: this.$route.query.term_id,
        page: 1,
        limit: 15,
        title: "",
        status: "",
        type: "",
        status: "",
      },
      dialogVisible:false,
      updateLoading: false,
      baijiayunPeriod: {
        id: this.$route.query.id,
        term_id: this.$route.query.term_id,
        title: "",
        type: 2,
        video_id: ""
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    createBaijiayunPeriod() {
        baiJiaYunVideoCreatePeriod(this.baijiayunPeriod).then((response) => {
        if (response.status == 2000) {
            this.baijiayunPeriod.title = "";
            this.baijiayunPeriod.video_id = "";
            this.dialogVisible = false;
          this.getList();
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },
    formatDateTime(datetime, fmt) {
      return formatDateTime(datetime, fmt);
    },
    durationShow(duration) {
      return formatSeconds(duration);
    },
    getList() {
      this.loading = true;
      getList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateSort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          updateSortPeriod({
            id: id,
            sort: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },

    updateStatus(id, status) {
      updateStatusPeriod({
        id: id,
        status: status,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },

    del(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deletePeriod({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
};
</script>

<style>
</style>